class LegacyProductMediaExtras {
  constructor(container) {
    this.container = container;
    this.setupProofPoints();
    this.setupVideo();
    this.setupStories();
  }

  setupVideo() {
    const videoSection = this.container.querySelector('[data-legacy-product-video]');
    const video = videoSection?.querySelector('video');
    const button = videoSection?.querySelector('[data-legacy-video-sound-button]');
    const unmuteIcon = videoSection?.querySelector('[data-legacy-video-unmute]');
    const muteIcon = videoSection?.querySelector('[data-legacy-video-mute]');
    if (!video || !button || !unmuteIcon || !muteIcon) return;

    button.addEventListener('click', (event) => {
      event.stopPropagation();
      video.muted = !video.muted;
      unmuteIcon.classList.toggle('is-hidden', video.muted);
      muteIcon.classList.toggle('is-hidden', !video.muted);
      button.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
    });
  }

  setupProofPoints() {
    const proofPoints = this.container.querySelector('[data-legacy-proof-points]');
    if (!proofPoints) return;

    const pins = [...proofPoints.querySelectorAll('[data-legacy-proof-pin]')];
    const titles = [...proofPoints.querySelectorAll('[data-legacy-proof-title]')];
    const progress = proofPoints.querySelector('[data-legacy-proof-progress]');
    let activeIndex = 0;

    const setActive = (index) => {
      activeIndex = (index + pins.length) % pins.length;
      pins.forEach((pin, pinIndex) => pin.classList.toggle('is-active', pinIndex === activeIndex));
      titles.forEach((title, titleIndex) => title.classList.toggle('is-active', titleIndex === activeIndex));
      if (progress) progress.style.transform = `scaleX(${(activeIndex + 1) / pins.length})`;
    };

    pins.forEach((pin, index) => pin.addEventListener('click', () => setActive(index)));
    proofPoints.querySelector('[data-legacy-proof-previous]')?.addEventListener('click', () => setActive(activeIndex - 1));
    proofPoints.querySelector('[data-legacy-proof-next]')?.addEventListener('click', () => setActive(activeIndex + 1));
    setActive(0);
  }

  setupStories() {
    const stories = this.container.querySelector('[data-legacy-product-stories]');
    if (!stories) return;

    const slides = [...stories.querySelectorAll('[data-legacy-story-slide]')];
    const progress = [...stories.querySelectorAll('[data-legacy-story-progress]')];
    if (slides.length < 2) return;
    let activeIndex = 0;

    const setActive = (index) => {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === activeIndex;
        slide.hidden = !isActive;
        slide.classList.toggle('is-active', isActive);
        const video = slide.querySelector('video');
        if (video) isActive ? video.play().catch(() => {}) : video.pause();
      });
      progress.forEach((segment, segmentIndex) => segment.classList.toggle('is-active', segmentIndex === activeIndex));
    };

    stories.querySelector('[data-legacy-story-previous]')?.addEventListener('click', () => setActive(activeIndex - 1));
    stories.querySelector('[data-legacy-story-next]')?.addEventListener('click', () => setActive(activeIndex + 1));
  }
}

document.querySelectorAll('.legacy-product-media-extras').forEach((container) => {
  if (container.dataset.legacyProductMediaInitialized) return;

  container.dataset.legacyProductMediaInitialized = 'true';
  new LegacyProductMediaExtras(container);
});
